import { TypeBox } from '../TypeBox/TypeBox'
import { useState } from 'react'
import { ScoopButton, ScoopSpinner, ScoopText, ScoopDialog, ScoopColumn } from '../../../../ui'
import styles from './SelectAPIorReport.module.scss'

export const SelectAPIorReport = ({
    setStep,
    onClose,
    setType,
    isLoading,
    handleContinue,
    sourceName,
    stepBack,
}) => {
    const [active, setActive] = useState('API Data Source')

    return (
        <ScoopDialog
            maxWidth="md"
            open
            onClose={() => {
                onClose()
                setStep(0)
            }}
            actions={
                <>
                    <ScoopButton
                        variant="grey"
                        onClick={() => {
                            setType(active)
                            setStep(0)
                            stepBack()
                        }}
                    >
                        Back
                    </ScoopButton>
                    <ScoopButton
                        disabled={!active || isLoading}
                        onClick={() => {
                            setType(active)
                            handleContinue(active)
                        }}
                    >
                        Continue
                    </ScoopButton>
                </>
            }
        >
            <ScoopColumn className={styles.container}>
                <ScoopText className={styles.title}>Create New Dataset</ScoopText>
                <ScoopText className={styles.description}>
                    Select the method you would like to use to scoop {sourceName} data.
                </ScoopText>
                <ScoopColumn className={styles.optionsContainer}>
                    <TypeBox
                        title={'Report Data Source'}
                        description={
                            'Utilize a ' +
                            sourceName +
                            ' report for your data source. This leverages our report "Scooping" technology where you can define your report in Hubspot, and Scoop will read it.'
                        }
                        active={active}
                        setActive={setActive}
                        enabled={true}
                    ></TypeBox>
                    <TypeBox
                        title={'API Data Source'}
                        description={
                            'This leverages lower level data APIs. Here you can pull data from a single ' +
                            sourceName +
                            ' object with some simple filtering options. '
                        }
                        active={active}
                        setActive={setActive}
                        enabled={true}
                    ></TypeBox>
                </ScoopColumn>
                {isLoading && <ScoopSpinner size={72} />}
            </ScoopColumn>
        </ScoopDialog>
    )
}
